import { render, staticRenderFns } from "./infoSetBirthdayPage.vue?vue&type=template&id=1074d5f3&scoped=true&"
import script from "./infoSetBirthdayPage.vue?vue&type=script&lang=js&"
export * from "./infoSetBirthdayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074d5f3",
  null
  
)

export default component.exports